<button
  *ngIf="isVisible"
  (click)="scrollToTop()"
  class="fixed bottom-6 z-[50] right-6 shadow-xl bg-gradient-to-br from-amber-500 to-amber-600 hover:from-amber-600 hover:to-amber-700 flex justify-center items-center rounded-full p-3 hover:scale-105 transition-transform animate-bounce-soft"
  aria-label="Remonter en haut"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    class="size-4"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
    />
  </svg>
</button>
